import React from 'react'
import get from 'lodash/get'

import User, { IUser } from './user'
import Text from './text'
import ImageList, { ImageItem } from './imageList'
import Answer, { IAnswer } from './answer'
import Interact, { IInteract } from './interact'
import { processUrlWith_tplv_noop } from 'lib/optimize-image'
import dynamic from 'next/dynamic'
import Loading from 'Components/loading'

export interface IQA extends IInteract {
  user_info: IUser
  content: string
  image_list?: ImageItem[]
  comment_list: IAnswer[]
  question_info: {
    send_award: string
    award_icon_url: string
  }
  link_info?: {
    image_url: string
  }
  video_thumb_url?: ImageItem[]
  video_id?: string
}

interface IProps {
  info: IQA
}

const Player = dynamic(() => import('Components/player'), {
  ssr: false,
  loading: () => <Loading />,
})

const QA = ({ info }: IProps) => {
  const {
    group_id,
    ugcType,
    user_info,
    content,
    image_list,
    comment_list,
    behot_time,
    comment_count,
    digg_count,
    user_digg,
    label_tag_list,
    question_info,
    link_info,
    video_id,
    video_thumb_url,
  } = info
  const cover = processUrlWith_tplv_noop(
    get(video_thumb_url, '0.uri') || get(image_list, '0.uri'),
    1000
  )
  const { image_url } = link_info || {}
  const answer = get(comment_list, '0', {})
  const { adopted } = answer
  return (
    <div className="ugc-qa">
      <div className="user-wrapper">
        <User info={user_info} />
      </div>

      <div className="ugc-content">
        <div className="text-wrapper">
          <Text text={content} />
        </div>
        {image_list && image_list.length > 0 && (
          <div className="image-wrapper">
            <ImageList list={image_list} />
          </div>
        )}
        {video_id && (
          <div
            className="cover-wrapper"
            onClick={(e: React.MouseEvent) => {
              e.stopPropagation()
              e.preventDefault()
            }}
          >
            <Player
              className={`tw-h-full`}
              group_id={group_id}
              vid={video_id}
              height={'100%'}
              width={'100%'}
              autoplay={false}
              cover={cover}
              setPIP={false}
            />
          </div>
        )}

        {adopted ? <Answer info={{ image_url, ...answer }} /> : null}
        <div className="interact-wrapper">
          <Interact
            info={{
              group_id,
              ugcType,
              behot_time,
              comment_count,
              digg_count,
              user_digg,
              isQA: true,
              adopted,
              question_info,
              label_tag_list,
            }}
          />
        </div>
      </div>
      <style jsx>
        {`
          .ugc-content {
            padding-left: 60px;
          }
          .text-wrapper {
            margin-top: 11px;
          }
          .image-wrapper {
            margin-top: 8px;
          }
          .cover-wrapper {
            height: 374px;
            margin-top: 8px;
          }
          .cover {
            position: relative;
            height: 100%;
            background-size: contain;
            background-position: center center;
            background-color: #000000;
            background-repeat: no-repeat;
            transition: all 0.5s;
          }
          .cover:hover {
            transform: scale(1.1);
            transform-origin: center;
          }
          .cover::after {
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 48px;
            height: 48px;
            background-color: rgba(0, 0, 0, 0.5);
            border-radius: 50%;
            background-image: url('https://sf1-ttcdn-tos.pstatp.com/obj/motor-img/81c16ecb55fae398c44652173375536b');
            background-size: 17.5px 19.7px;
            background-repeat: no-repeat;
            background-position: 17.5px 14.1px;
          }
          .interact-wrapper {
            margin-top: 16px;
          }
        `}
      </style>
    </div>
  )
}

export default QA
